import api from './axios';

const formatRelative = (iso) => {
  if (!iso) return '';
  const diffMs = Date.now() - new Date(iso).getTime();
  const days = Math.floor(diffMs / (1000 * 60 * 60 * 24));
  if (days <= 0) return 'Danas';
  if (days === 1) return 'Pre 1 dana';
  if (days < 30) return `Pre ${days} dana`;
  const months = Math.floor(days / 30);
  if (months === 1) return 'Pre 1 meseca';
  if (months < 12) return `Pre ${months} meseca`;
  const years = Math.floor(months / 12);
  return years === 1 ? 'Pre 1 godine' : `Pre ${years} godine`;
};

const DELIVERY_LABELS = {
  licno: 'Lično',
  adresa: 'Na adresu',
  posta: 'Poštom',
};

export const normalizeProduct = (p) => {
  if (!p) return p;
  const rawImages = Array.isArray(p.images) ? p.images : [];
  const idx = Math.min(Math.max(p.mainImageIndex ?? 0, 0), Math.max(rawImages.length - 1, 0));
  // Reorder so the main image is always first; remaining images keep their relative order.
  const orderedImages = rawImages.length > 0
    ? [rawImages[idx], ...rawImages.filter((_, i) => i !== idx)]
    : (p.image ? [{ url: p.image }] : []);
  const imageUrls = orderedImages.map((img) => (typeof img === 'string' ? img : img?.url)).filter(Boolean);
  const mainImage = imageUrls[0] || '';

  const ownerName = p.seller?.name?.trim() || '';
  const householdName = p.domacinstvoId?.name?.trim() || '';
  const sellerName = householdName || ownerName || 'Domaćinstvo';

  return {
    ...p,
    id: p._id || p.id,
    image: mainImage,
    images: orderedImages,
    imageUrls,
    location: p.municipality || p.location || '',
    sellerName,
    ownerName,
    householdName,
    sellerPhone: p.domacinstvoId?.phone || '',
    createdAt: formatRelative(p.createdAt),
    statusKey: p.status || 'active',
    status: p.status === 'sold' ? 'Rasprodat' : 'Aktivan',
    deliveryMethodLabel: DELIVERY_LABELS[p.deliveryMethod] || '',
  };
};

const productsService = {
  getAll: async (params = {}) => {
    const res = await api.get('/products', { params });
    const data = res.data || {};
    return {
      ...res,
      data: {
        ...data,
        items: Array.isArray(data.items) ? data.items.map(normalizeProduct) : [],
      },
    };
  },

  getById: (id) => {
    return api.get(`/products/${id}`);
  },

  getOne: async (idOrSlug) => {
    const res = await api.get(`/products/${idOrSlug}`);
    return { ...res, data: normalizeProduct(res.data) };
  },

  getMine: async () => {
    const res = await api.get('/products/my');
    const data = res.data || {};
    return {
      ...res,
      data: {
        ...data,
        items: Array.isArray(data.items) ? data.items.map(normalizeProduct) : [],
      },
    };
  },

  create: (formData) => {
    return api.post('/products', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  update: (id, formData) => {
    return api.put(`/products/${id}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },

  delete: (id) => {
    return api.delete(`/products/${id}`);
  },

  getByCategory: (category) => {
    return api.get(`/products/category/${category}`);
  },

  getByMunicipality: (municipality) => {
    return api.get(`/products/municipality/${municipality}`);
  },
};

export default productsService;
